import { FC, useEffect, useState } from "react";
import styles from "./token-progress-widget.module.scss";

interface TokenSaleProgressWidgetProps {
  totalTokens?: number;
  softCap: number;
  soldTokens: number;
  currency: string;
  ticker: string;
}

const TokenSaleProgressWidget: FC<TokenSaleProgressWidgetProps> = ({
  softCap,
  ticker,
  totalTokens,
  soldTokens,
  currency,
}) => {
  const [percentage, setPercentage] = useState(0);
  const [softCapPercentage, setSoftCapPercentage] = useState(0);

  useEffect(() => {
    if (totalTokens) {
      setPercentage((soldTokens / totalTokens) * 100);
      setSoftCapPercentage((softCap / soldTokens) * 100);
    } else {
      setPercentage(0);
      setSoftCapPercentage(0);
    }
  }, [soldTokens, totalTokens, softCap]);

  return (
    <div className={styles.widget}>
      <div className={styles.header}>
        <h3 className={styles.title}>{ticker} Token Sale Progress:</h3>
      </div>
      {totalTokens && (
        <div className={styles.info}>
          <span>{`SoftCap: ${softCap.toLocaleString()} ${currency}`}</span>
          <span>{`HardCap: ${totalTokens.toLocaleString()} ${currency}`}</span>
        </div>
      )}
      <div className={styles.progressBarContainer}>
        <div className={styles.progressBar} style={{ width: `${percentage}%` }}>
          {totalTokens && softCapPercentage > 0 && softCapPercentage < 100 && (
            <div
              className={styles.softCapMarker}
              style={{ left: `${softCapPercentage}%` }}
            />
          )}
        </div>
        <div
          className={styles.raisedContainer}
          style={{ left: `${percentage}%` }}
        >
          <div className={styles.raisedPointer} />
          <div className={styles.raisedLabel}>
            Raised: {soldTokens.toLocaleString()} {currency}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TokenSaleProgressWidget;
